import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-attachment",
  "use": "icon-cms-attachment-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-attachment\"><path d=\"M74.29,197.16A49.24,49.24,0,0,1,39.46,113.1l79.39-79.38A37.23,37.23,0,1,1,171.5,86.37l-77,77A27.21,27.21,0,1,1,56,124.91l72.77-72.77,6.37,6.36L62.36,131.27A18.21,18.21,0,0,0,88.11,157l77-77a28.23,28.23,0,0,0-39.92-39.93L45.82,119.47a40.26,40.26,0,0,0,56.93,56.93l84.53-84.53,6.37,6.36-84.53,84.53A49.13,49.13,0,0,1,74.29,197.16Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol